module.exports = __webpack_public_path__ + "img/13.1.154c5854.png";